/* lmm-semantic-filter.js — TUEV-17 D-7 Phase 2d: semantischer CRI-Einstieg
   (Chris 2026-08-17)

   ZWECK
   Ratgeber- und Kampagnenlinks sollen dauerhaft auf eine Filterstufe zeigen
   koennen, ohne die heute zufaellig vorhandenen specs.cri-Rohwerte einzufrieren.
   Beispiel: /collections/led-lampen?lmm_cri=90

   PRINZIP — SINGLE SOURCE OF TRUTH
   Dieses Script kennt KEINEN CRI-Wert, KEINE Schwelle und KEINE Filterlogik.
   Es liest den Marker, sucht die vom Theme bereits serverseitig gerenderte
   Stufe (sections/lmm-collection-list.liquid, Attribut data-lmm-tier) und
   uebernimmt deren fertigen href unveraendert. Die Fachlogik — Ziffernextraktion
   aus dem Rohwert, Stufenschwelle, Erhalt der uebrigen Filter und der Sortierung
   ueber base_q — bleibt vollstaendig in Liquid. Es wird keine Filter-URL selbst
   zusammengesetzt.

   FAIL-SAFE
   Jeder unerwartete Zustand ist ein No-Op: kein Marker, leerer oder unbekannter
   Wert, Stufe nicht gerendert (Liquid gibt sie bei 0 Treffern nicht aus), Stufe
   bereits aktiv, nativer CRI-Filter schon in der URL, fehlender oder fremder
   href. Dann bleibt exakt die Seite stehen, die der Server ausgeliefert hat.

   LOOP-SICHERHEIT
   Der uebernommene href stammt aus base_q und kann den Marker nicht enthalten,
   weil Liquid ihn nie sieht. Zusaetzlich wird das Ziel geprueft: enthaelt es
   lmm_cri, zeigt es auf einen anderen Host oder Pfad oder ist es die aktuelle
   Adresse, passiert nichts. location.replace() erzeugt keinen History-Eintrag.

   PROGRESSIVE ENHANCEMENT
   Ohne JavaScript liefert ?lmm_cri=90 unveraendert die ungefilterte Collection —
   derselbe Zustand wie heute. Der Marker erzeugt serverseitig nichts, ist nicht
   Teil des Shopify-Cache-Keys und wird per Canonical auf die Collection
   zurueckgefuehrt. */
(function () {
  'use strict';

  if (window.__lmmSemanticFilterInit) { return; }
  window.__lmmSemanticFilterInit = true;

  var MARKER = 'lmm_cri';
  /* Unterstuetzte Marker der drei vom Theme gerenderten Stufen (Ra 80+/90+/95+).
     Das sind bewusst KEINE CRI-Rohwerte, sondern nur die erlaubten Markerwerte. */
  var STUFEN = ['80', '90', '95'];
  var NATIV = 'filter.p.m.specs.cri';

  function aufloesen() {
    var params = new URLSearchParams(window.location.search);

    /* Deterministisch: bei Mehrfachangabe gewinnt der ERSTE Wert. */
    var stufe = params.get(MARKER);
    if (!stufe) { return; }
    stufe = String(stufe).trim();
    if (STUFEN.indexOf(stufe) === -1) { return; }

    /* Ist bereits ein nativer CRI-Filter gesetzt, wird nicht eingegriffen. */
    if (window.location.search.indexOf(NATIV) !== -1) { return; }

    var facette = document.querySelector('[data-facet="cri"]');
    if (!facette) { return; }

    var ziel = facette.querySelector('a.lmf__opt[data-lmm-tier="' + stufe + '"]');
    if (!ziel) { return; }

    /* Ist die Stufe aktiv, ist ihr href der Entfernen-Link — nicht folgen. */
    if (String(ziel.className || '').indexOf('is-active') !== -1) { return; }

    var roh = ziel.getAttribute('href');
    if (!roh) { return; }

    var url = new URL(roh, window.location.href);
    if (url.origin !== window.location.origin) { return; }
    if (url.pathname !== window.location.pathname) { return; }
    if (url.search.indexOf(MARKER) !== -1) { return; }
    if (url.href === window.location.href) { return; }

    window.location.replace(url.href);
  }

  function starten() {
    try { aufloesen(); } catch (fehler) { /* jeder Fehler bleibt ein No-Op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
}());
